<template>
  <section class="voucher">
    <div class="jumbotron jumbotron-fluid">
      <div class="container-fluid fade-in">
        <h1 class="text-center">Gutscheine</h1>
        <div class="row text-center">
          <div class="col-12">
            <p style="font-size:19px;">Immer eine gute Idee.</p>
            <p class="text-2">Verschenken Sie einen Wohlfühlmoment.</p>
            <p class="text-2">Individuelle Gutscheine bei mir erhältlich.</p>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "Voucher"
}
</script>

<style lang="scss">
@import 'src/assets/scss/imports';

h1, h2, p {
  color: white;
}

h1 {
  text-transform: uppercase;
  letter-spacing: 4px;
}

.jumbotron {
  position: relative;
  background: $black;
  padding: 25px 0;

  .container-fluid {
    max-width: 95%;
  }
}
</style>
